import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

export default {
    defaultProps: {
        currentPageButtonVariant: "outline",
        cssOverrides: {
            perPageSelect: css`
                //display: none;
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: none;
                            `,
                            null,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )};
            `,
            pagination: css`
                justify-content: center;
            `,
            currentButton: css`
                border: 0;
                &:not(:disabled):hover {
                    background: transparent;
                }

                span {
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    color: ${COLORS.text.base};
                }
            `,
        },
    },
};
